import axios from '../axios'
// 查询用户列表
export const query = (data) => {
    return axios({
      url: '/backend/case/query',
      method: 'GET',
      data: data
    })
}
export const operate = (data) => {
  return axios({
    url: '/backend/case/operate',
    method: 'POST',
    data: data
  })
}
export const deleteCase = (data) => {
  return axios({
    url: '/backend/case/delete',
    method: 'POST',
    data: data
  })
}
export const insertCase = (data) => {
  return axios({
    url: '/backend/case/insert',
    method: 'POST',
    data: data
  })
}
export const updateCase = (data) => {
  return axios({
    url: '/backend/case/update',
    method: 'POST',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/user.js